import { createApp } from 'vue'
import ElementUI from 'element-plus'
import App from './App.vue'
import 'element-plus/dist/index.css'

createApp(App).use(ElementUI).mount('#app')
